(() => {
  const videos = document.querySelectorAll('.eldra-chi-siamo-story__media video[data-eldra-story-video]');
  if (!videos.length) return;

  const playVideo = (video) => {
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
    const run = video.play();
    if (run && typeof run.catch === 'function') run.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => playVideo(video));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) playVideo(video);
        else video.pause();
      });
    },
    { rootMargin: '80px 0px', threshold: 0.2 }
  );

  videos.forEach((video) => observer.observe(video));
})();
